export default "__VITE_ASSET__Bee$RfKk__"